import { makeAutoObservable } from 'mobx';


export type User = {
    id: string,
    name: string
}

type Session = {
    user: User,
    jwt: string,
    refreshToken: string,
}

export class AuthStore {
    jwt: string | null = null
    refreshToken: string | null = null
    user: User | null = null

    constructor() {
        makeAutoObservable(this)
    }

    loadSessionFromLocalStorage() {
        const sessionString = localStorage.getItem('session')
        if (sessionString) {
            const session: Session = JSON.parse(sessionString)
            // TODO validate jwt before setting
            this.user = session.user
            this.jwt = session.jwt
            this.refreshToken = session.refreshToken
        }
    }

    clearLocalStorage() {
        localStorage.removeItem('session');
    }

    saveSessionToLocalStorage() {
        if (this.user && this.jwt && this.refreshToken) {
            const session: Session = { user: this.user, jwt: this.jwt, refreshToken: this.refreshToken }
            localStorage.setItem('session', JSON.stringify(session))
        }
    }

    refreshJwt(jwt: string) {
        this.jwt = jwt
        this.saveSessionToLocalStorage()
    }

    login(user: User, jwt: string, refreshToken: string) {
        this.user = user
        this.jwt = jwt
        this.refreshToken = refreshToken
        this.saveSessionToLocalStorage()
    }

    logout() {
        this.user = null
        this.jwt = null
        this.clearLocalStorage()
    }
}